import React, {useContext} from 'react';
import {ShippingInstructionContext} from "./shipping-instruction-context";
import {Card as MuiCard, Container as MuiContainer, Divider as MuiDivider, Grid} from '@mui/material'
import StatementSection from "./statement-section";
import DocumentSection from "./document-section";
import styled from "styled-components/macro";
import {spacing} from "@mui/system";
import OtherDocumentSection from './otherDocument-section';


const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);
const Container = styled(MuiContainer)(spacing);


const ShippingInstructionSections = ({checkInnerChildModified}) => {
   
  const checkIfDirty = (dirty) => {
         if(dirty){
            checkInnerChildModified(dirty)
         }
    }
    const {sections} = useContext(ShippingInstructionContext);

    return (
        <Container>
            <Divider my={6}/>
            <Grid>
                {
                    sections.filter(s => s.displayInEditor === true).map(s =>
                        (
                            <Card key={s.id}>
                                <Grid>
                                    <Grid item xs={12}>
                                        &nbsp;
                                    </Grid>
                                    <Grid item xs={12}>
                                        <h3>
                                            {s.title}
                                        </h3>
                                    </Grid>
                                    <Grid item xs={12}>
                                        &nbsp;
                                    </Grid>
                                    {s.allowStatements === true && <Grid item xs={12}>
                                        <StatementSection section={s} checkIfDirty={checkIfDirty}/>
                                    </Grid>}

                                    {s.allowDocuments === true && <Grid item xs={12}>
                                        <DocumentSection section={s} checkIfDirty={checkIfDirty}/>
                                    </Grid>}
                                    {s.allowDocuments === true && <Grid item xs={12}>
                                        <OtherDocumentSection section={s} checkIfDirty={checkIfDirty}/>
                                    </Grid>}
                                </Grid>
                            </Card>
                        ))
                }
            </Grid>
        </Container>
    );
};

export default ShippingInstructionSections;
